import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { AgiSalesPreset } from './app.preset';
import { AdminModule } from './shared/layouts/admin/admin.module';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { TokenService } from './core/services/token.service';
import { ptBr } from './core/config/primeng-translate';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { cleanHttpParamsInterceptor } from './core/interceptors/clean-http-params.interceptor';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { provideFirebaseMessagingIfSupported } from './core/services/firebase-messaging.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AdminModule,
    HttpClientModule,
    ToastModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([cleanHttpParamsInterceptor, authInterceptor]),
    ),
    provideAnimationsAsync(),
    TokenService,
    MessageService,
    providePrimeNG({
      translation: ptBr,
      ripple: true,
      theme: {
        preset: AgiSalesPreset,
        options: {
          darkModeSelector: 'light',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    ...provideFirebaseMessagingIfSupported(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
